var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AmountInput',{ref:"input",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('span',{attrs:{"slot":"append"},slot:"append"},[_vm._v(_vm._s(_vm.appendValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }